import {DateTime, Duration} from "luxon";
/**
 * @property {string|null} id
 * @property {Textbase|null} textbase
 * @property {Text|null} text
 * @property {string|null} comment
 * @property {boolean|null} isViewed
 * @property {number|null} nbAttachments
 * @property {boolean|null} isInformational
 * @property {DateTime|null} reassessmentDate
 * @property {Object|null} stats
 * @property {number} stats.assessed
 * @property {number} stats.compliance.no
 * @property {number} stats.compliance.toCheck
 * @property {number} stats.compliance.yes
 * @property {number} stats.compliance.notAssessed
 * @property {number} stats.relevance.no
 * @property {number} stats.relevance.toCheck
 * @property {number} stats.relevance.yes
 * @property {number} stats.relevance.notAssessed
 * @property {number} stats.nbAssessableRequirements
 */
export default class Assignment {
    constructor() {
        this.id = null;
        this.text = null;
        this.comment = null;
        this.isViewed = false;
        this.nbAttachments = 0;
        this.isInformational = false;
        this.reassessmentDate = null;
        this.textbase = null;
        this.stats = {
            assessed: 0,
            "compliance.no": 0,
            "compliance.toCheck": 0,
            "compliance.yes": 0,
            "compliance.notAssessed": 0,
            "relevance.no": 0,
            "relevance.toCheck": 0,
            "relevance.yes": 0,
            "relevance.notAssessed": 0,
            nbAssessableRequirements: 0
        };
    }

    /**
     * Returns a new `Assignment` instance hydrated with data from given `api_resource`.
     *
     * Please note that `Assignment.text` and `Assignment.textbase` properties are not hydrated by this method.
     *
     * @param {Object} api_resource
     * @return {Assignment}
     */
    static fromAPI(api_resource) {
        let out = Object.assign(new Assignment(), {
            id: api_resource.id,
            comment: api_resource.comment,
            isViewed: api_resource.isViewed,
            nbAttachments: api_resource.nbAttachments,
            isInformational: api_resource.isInformational,
            reassessmentDate: (api_resource.reassessmentDate !== null
                ? DateTime.fromISO(api_resource.reassessmentDate)
                : null
            ),
            stats: api_resource.stats
        });
        out.stats.nbAssessableRequirements = api_resource.nbAssessableRequirements;
        out.stats = Object.assign(out.stats, api_resource.stats);
        return out;
    }

    /**
     * @return {Duration}
     */
    static get upcomingReassessmentDuration() {
        // noinspection JSCheckFunctionSignatures
        return Duration.fromISO("P2M");
    }
}
